import { Empty } from 'antd'
import { StoreState } from 'src/store/configureStore'
import PerformancePercentageWrapper from './PerformancePercentageWrapper'
import { useSelector } from 'react-redux'
import { AsyncStates } from 'src/constants'

export const PerformancePercentageResult = ({ index, property, currentSelectedStage }: any) => {
  const displayNames = useSelector((state: StoreState) => state.displayNames.data)

  const { performanceData, getPerformanceStatus } = useSelector((state: StoreState) => state.performance)

  const getDisplayName = (property: string) => {
    return performanceData?.display_names?.[property] ?? displayNames.properties?.[property]?.name ?? property
  }

  return Object.keys(performanceData.data_performance_percentage || {}).length > 0 &&
    Object.keys(performanceData.model_performance_percentage || {}).length > 0 &&
    Object.keys(performanceData.property_type || {}).length > 0 &&
    getPerformanceStatus === AsyncStates.SUCCESS ? (
    <PerformancePercentageWrapper
      data={performanceData?.data_performance_percentage[property].data}
      percentage={performanceData?.data_performance_percentage[property].perc_data}
      modelPercentageData={performanceData?.model_performance_percentage[property].data}
      modelPercentage={performanceData?.model_performance_percentage[property].perc_data}
      modelNames={performanceData?.model_performance_percentage[property].model_name}
      type={performanceData?.property_type[property]}
      currentSelectedStage={currentSelectedStage}
    />
  ) : (
    <Empty description={`No Data for ${getDisplayName(property)}`} />
  )
}
